import React from 'react';
// @ts-ignore
import styles from './EArchiveListItemStatusBadge.module.scss';
import { WorkplacePatientStatus } from '../../../Enums/WorkplacePatientStatus.enum';
import useTranslation from '../../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../../Utils/className.util';

interface Props {
	status: WorkplacePatientStatus;
	hasMeddi: boolean;
}

interface BadgeProps {
	title: string;
	className: string;
}

export const Badge: React.FC<BadgeProps> = ({ title, className }) => {
	const { t } = useTranslation();

	return (
		<div className={joinClasses([styles.wrapper, styles[className]])}>
			{t(title)}
		</div>
	);
};

const EArchiveListItemStatusBadge: React.FC<Props> = ({ status, hasMeddi }) => {
	switch (status) {
		case WorkplacePatientStatus.PENDING:
			return <Badge title='base.inviteSended' className='gray' />;
		case WorkplacePatientStatus.VIRTUAL:
			return <Badge title='base.waitingForInviteToMeddi' className='orange' />;
		case WorkplacePatientStatus.DECLINED:
			return <Badge title='base.invitationDeclined' className='red' />;
		case WorkplacePatientStatus.ARCHIVED:
		case WorkplacePatientStatus.ARCHIVED_BY_PATIENT:
		case WorkplacePatientStatus.ARCHIVED_BY_WORKPLACE:
			return <Badge title='base.archived' className='gray' />;
	}

	return <></>;
};

export default EArchiveListItemStatusBadge;
